import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { EHashLinks } from '@enum';

export const useSetActiveClass = () => {
  const { hash } = useLocation();

  return useCallback(
    (current: EHashLinks): string =>
      current === hash.replace('#', '') ? 'active' : '',
    [hash],
  );
};
